import Mock from 'mockjs'
import homeApi from './mockServerData/home'
import permission from './mockServerData/permission'

Mock.mock(
    '/api/home/getData', homeApi.getStatisticalData
)
Mock.mock('/api\/permission\/getMenu','post', permission.getMenu)